<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEmailAlertOutline } from "@mdi/js";
export default {
  name: "MdiEmailAlertOutline",
  data() {
    return {
      svgPath: mdiEmailAlertOutline,
    };
  },
};
</script>
